import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { IBreadcrumbItem } from "libraries/service/breadcrumb/IBreadcrumbItem";
import { QuotationBreadcrumbService } from "../breadcrumb/quotation-breadcrumb.service";
import { Router } from "@angular/router";

@Component({
    selector: 'quotation-layout',
    template: `
        <div class="app-wrapper app-quotation">
            <quotation-breadcrumb [showCloseButton]="showCloseButton"
                                  (onClose)="onClose.emit()"
                                  (onNotify)="onNotify.emit($event)"
                                  (onNext)="onNext.emit()"
                                  [items]="breadcrumbItems"></quotation-breadcrumb>
            <ng-content select=".app-content"></ng-content>
        </div>`,
    styles: [ `
        .app-quotation {
            width: auto;
            max-width: unset;
            margin: calc(50px + .75rem) .75rem .75rem .75rem;
        }
    ` ],
})

export class QuotationLayoutComponent {
    @Input()
    public showCloseButton: boolean = false;
    @Input()

    public breadcrumbItems: IBreadcrumbItem[];

    @Output()
    public readonly onClose: EventEmitter<null> = new EventEmitter();
    @Output()
    public readonly onNext: EventEmitter<null> = new EventEmitter();
    @Output()
    public readonly onNotify: EventEmitter<null> = new EventEmitter<null>();

}